import { render, staticRenderFns } from "./DeleteRecordingDialog.vue?vue&type=template&id=ddee6ce8&scoped=true"
import script from "./DeleteRecordingDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRecordingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee6ce8",
  null
  
)

export default component.exports